import {EnvironmentProviders, ErrorHandler, Provider} from '@angular/core';
import {createErrorHandler, TraceService} from '@sentry/angular';
import {Router} from '@angular/router';
import {isUnauthorizedHttpError} from '../util/is-unauthorized-http-error.util';

const SENTRY_ERROR_HANDLER = createErrorHandler({
    showDialog: false, // @TODO: Show dialog for users to give feedback
});

export const SENTRY_PROVIDERS: Array<Provider | EnvironmentProviders> = [
    {
        provide: ErrorHandler,
        useValue: {
            handleError: (error: unknown): void => {
                if (isUnauthorizedHttpError(error)) {
                    return;
                }
                SENTRY_ERROR_HANDLER.handleError(error);
            },
        },
    },
    {
        provide: TraceService,
        deps: [Router]
    },
];
